import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { Checkbox, Form, FormFieldProps, Label } from 'semantic-ui-react'

interface Iprops extends FieldRenderProps<boolean, HTMLElement>,
    FormFieldProps { }

const CheckboxInput: React.FC<Iprops> = ({
    input,
    width,
    meta: { touched, error }
}) => {
    return (
        <Form.Field name={input.name} error={touched && !!error} width={width} >
            <Checkbox
                {...input}
                id={input.name}
                name={input.name}
                type={'checkbox'}
                onChange={input.onChange}
                value={input.checked ? 'true' : 'false'}
            />

            {touched && error && (
                <Label basic color='red'>
                    {error}
                </Label>
            )}
        </Form.Field>
    );
};
export default CheckboxInput;
